import {useCheckPermission} from "../../hooks/permissionHooks";
import {RevaPermission} from "../../util/revaPermission";
import ParameterInputCategoryButtons from "./ParameterInputCategoryButtons";

export default function ParameterInputValuationApproach(props) {
    const hasNhkBki = useCheckPermission(RevaPermission.INDICATION_VALUES_NHK_BKI);
    return <ParameterInputCategoryButtons {...props} maxCategories={hasNhkBki ? undefined : 2} />;
}
